import { marked } from 'marked';
import DOMPurify from 'dompurify';

// `breaks: true` turns a single newline into <br>, which matches the way the
// old plain-text fields were rendered with `white-space: pre-line`. `gfm`
// adds tables / strikethrough / auto-links — all useful, no extra cost.
marked.setOptions({ breaks: true, gfm: true });

// Keep external links safe: force rel/target so a sanitized <a> can't be used
// for reverse-tabnabbing, and strip anything DOMPurify flags.
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer nofollow');
  }
});

/**
 * Renders Markdown (mostly admin-authored) into HTML for injection with
 * Svelte's `{@html ...}`. `marked` passes raw HTML through unchanged, so the
 * output is ALWAYS run through DOMPurify — this is the security boundary that
 * neutralizes `<script>`, `on*=` handlers, `javascript:`/`data:` URLs and
 * `<iframe>` even if a write path is ever compromised or mis-gated. Defense in
 * depth: never rely on "only admins can author this".
 */
export function renderMarkdown(text: string | null | undefined): string {
  if (!text) return '';
  const raw = marked.parse(text) as string;
  return DOMPurify.sanitize(raw, {
    ALLOWED_URI_REGEXP: /^(?:https?:|mailto:|tel:|#|\/)/i,
  });
}
